import React, { useEffect, useState } from "react";
import "./BannerSlider.css";
import { Link } from "react-router-dom";

const MOBILE_BREAKPOINT = 1024;

const banners = [
  {
    alt: "Bank of India home loan offer",
    file: "Bank Of India-m.png",
  },
  {
    alt: "Bank of Baroda home loan offer",
    file: "Bank Of Baroda-m.png",
  },
  {
    alt: "ICICI Bank home loan offer",
    file: "ICICI bank-m.png",
  },
  {
    alt: "Bank of Maharashtra home loan offer",
    file: "Bank Of Maharashtra-m.png",
  },
  {
    alt: "Central Bank of India home loan offer",
    file: "central bank of india-m.png",
  },
  {
    alt: "State Bank of India home loan offer",
    file: "SBI Bank-m.png",
  },
  {
    alt: "IDBI Bank home loan offer",
    file: "IDBI Bank-m.png",
  },
  {
    alt: "HDFC Bank home loan offer",
    file: "HDFC Bank-m.png",
  },
  {
    alt: "Indian Overseas Bank home loan offer",
    file: "Indian overseas Bank-m.png",
  },
];

const BannerSlider = () => {
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(() =>
    typeof window !== "undefined"
      ? window.innerWidth <= MOBILE_BREAKPOINT
      : false
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(max-width: ${MOBILE_BREAKPOINT}px)`
    );

    const handleScreenChange = (event) => {
      setIsMobileOrTablet(event.matches);
    };

    setIsMobileOrTablet(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleScreenChange);
    } else {
      mediaQuery.addListener(handleScreenChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleScreenChange);
      } else {
        mediaQuery.removeListener(handleScreenChange);
      }
    };
  }, []);

  if (!isMobileOrTablet) {
    return null;
  }

  return (
    <section
      className="elementor-banner-slider"
      aria-label="Monayra loan offers"
    >
      <div className="banner-slider-background-glow banner-glow-one"></div>
      <div className="banner-slider-background-glow banner-glow-two"></div>

      <div
        id="elementorBannerSliderMobile"
        className="carousel slide carousel-fade banner-carousel"
        data-bs-ride="carousel"
        data-bs-interval="5000"
        data-bs-pause="hover"
        data-bs-touch="true"
      >
        <div className="banner-slider-indicators carousel-indicators">
          {banners.map((banner, index) => (
            <button
              key={banner.file}
              type="button"
              data-bs-target="#elementorBannerSliderMobile"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`View offer ${index + 1}`}
            />
          ))}
        </div>

        <div className="carousel-inner banner-carousel-inner">
          {banners.map((banner, index) => (
            <div
              key={banner.file}
              className={`carousel-item banner-carousel-item ${
                index === 0 ? "active" : ""
              }`}
            >
              <Link
                to="/apply-now"
                className="banner-slide-link"
                aria-label={`Apply for ${banner.alt}`}
              >
                <div className="banner-image-wrapper">
                  <img
                    src={`/images/Banner-Mobile/${banner.file}`}
                    className="banner-slide-img"
                    alt={banner.alt}
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchPriority={index === 0 ? "high" : "auto"}
                  />

                  <div className="banner-image-overlay"></div>

                  <div className="banner-slider-action">
                    <span>Explore Loan Offer</span>
                    <i className="bi bi-arrow-up-right"></i>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev banner-control banner-control-prev"
          type="button"
          data-bs-target="#elementorBannerSliderMobile"
          data-bs-slide="prev"
          aria-label="View previous loan offer"
        >
          <span className="banner-control-icon" aria-hidden="true">
            <i className="bi bi-chevron-left"></i>
          </span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next banner-control banner-control-next"
          type="button"
          data-bs-target="#elementorBannerSliderMobile"
          data-bs-slide="next"
          aria-label="View next loan offer"
        >
          <span className="banner-control-icon" aria-hidden="true">
            <i className="bi bi-chevron-right"></i>
          </span>
          <span className="visually-hidden">Next</span>
        </button>

        <div className="banner-slider-progress">
          <span></span>
        </div>
      </div>
    </section>
  );
};

export default BannerSlider;